/* eslint-disable */
// import lib(s)
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import _ from 'lodash';

// import styles 
import styles from './CustomRadioGroup.css';
import CommonStyles from '../../CommonStyles.css';

// custom wrapper styles
const useStyles = makeStyles(theme => ({
  // base style of Component
  labelStyle: {
    '& .MuiFormControlLabel-label': {
      fontSize: 14,
    },
  }
}));

/** MaterialUI component - Radio Group
 * Using wrapper style and custom props / function
 * Props /use 
    label - label annotation 
    mandatory - required property,
    value - selected value
    color - Radio selection color,
    size - materialUI defined sizes - 'medium'| 'small',
    options - radio options
    onChange - input on change fn,
    valueKey - key to use for value,
    labelKey - key to use for display item label,
    stateKey - key name reference to update the sate in component
 * */
const CustomRadioGroup = props => {
  const classes = useStyles();
  const {
    label = '',
    mandatory = false,
    color,
    size = '',
    value = {},
    handleChange,
    options = [],
    valueKey,
    labelKey,
    stateKey,
  } = props;

  return <React.Fragment>
    <InputLabel shrink className={styles.label}>
      {label}
      {mandatory &&
        <label className={CommonStyles.asterisk}>&#x2a;
        </label>
      }
    </InputLabel>
    <RadioGroup
      row aria-label={label}
      name={label}
      value={value}
      onChange={(e) => handleChange(e, stateKey)}>
      {options.length > 0 &&
        options.map(item => {
          return <FormControlLabel
            key={item[valueKey]}
            className={classes.labelStyle}
            value={item[valueKey]}
            control={<Radio
              color={color}
              size={size}
            />}
            label={item[labelKey]}
          />
        })
      }
    </RadioGroup>

  </React.Fragment>

}

export default CustomRadioGroup;



// WEBPACK FOOTER //
// ./src/views/components/Common/FormMUIWrapperComponents/CustomRadioGroup/CustomRadioGroup.jsx